/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

class SocialModalFooter extends React.Component {
    constructor(props) {
        super(props);

        this.returnToTypes = this.returnToTypes.bind(this);

    }

    returnToTypes(e) {
        e.preventDefault();

        this.props.backAction('chooseType');

    }

    render() {
        var saveAction = (this.props.isDirty) ? this.props.saveAction : null,
            saveClass = (this.props.isDirty) ? "" : "",
            socialLabel = (this.props.numberSelected === 1) ? "social" : "socials",
            saveClass = classnames(
				'btn-primary btn-modal',
				{
					'active': this.props.isDirty
				}
			),
            content = null,
            label = 'update',
            backButton = (
                <a href="#" className="modal-back-link" onClick={this.returnToTypes}>
                    back
                </a>
            );

        if (this.props.context === 'bulk-modal') {
            backButton = null;
            label = 'choose socials';
        }

        return (
            <div className="modal-footer-content">
                <div className="modal-footer-wrapper">
                    <div className="modal-footer-status">
                        {this.props.footerStatus}
                    </div>
                    <div className="modal-footer-buttons">
                        {backButton}
                        <button className={saveClass} onClick={saveAction}>
                            {label}
                        </button>
                    </div>
                </div>
            </div>
        );

    }

};

SocialModalFooter.displayName = "SocialModalFooter";

SocialModalFooter.propTypes = {
    numberSelected: PropTypes.number,
    backAction: PropTypes.func,
    saveAction: PropTypes.func,
    isDirty: PropTypes.bool,
    switchView: PropTypes.func
};

SocialModalFooter.defaultProps = {
    backAction: null,
    saveAction: null,
    isDirty: false,
    switchView: null,
    footerStatus: null
};

export default SocialModalFooter;
